<template>
  <div class="ks-vue-component">
    <div :class="formGroupClass">
      <div class="form__label-wrap">
        <template v-if="showLabel">
          <label class="form__label">{{ label }}</label>
          <div v-if="showOptionalText" class="form__optional">- optional</div>
          <div v-if="dirty" class="form__dirty-text">Unsaved</div>
        </template>
      </div>
      <div v-if="showHelpText" class="form__help">{{ helpText }}</div>
      <multiselect
        :value="value"
        @input="select"
        :options="options"
        :label="optionsLabel"
        :track-by="trackBy"
        placeholder
        :searchable="searchable"
        :multiple="true"
        :taggable="taggable"
        :disabled="disabled"
        :show-labels="showLabels"
        :allow-empty="!required && allowEmpty"
        :selected-label="selectedLabel"
        :select-label="selectLabel"
        :deselect-label="deselectLabel"
        :group-label="groupLabel"
        :group-values="groupValues"
        :open-direction="openDirection"
        @open="hasFocus = true"
        @close="hasFocus = false"
        @tag="addTag"
        @search-change="onSearchChange"
        :close-on-select="false"
        v-if="!forceView"
      >
        <template slot="selection" slot-scope="{ values, isOpen }">
          <span
            class="multiselect__single"
            v-if="!(isOpen && searchable) && values.length > 0"
          >{{ values.length }} selected</span>
          <span
            class="multiselect__single"
            v-if="!(isOpen && searchable) && values.length == 0"
          >{{ noneSelectedLabel }}</span>
        </template>
      </multiselect>
      <div class="view-mode" v-else>{{ value && value[optionsLabel] }}</div>
    </div>
    <!--<pre>{{ $v.value }}</pre>-->
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import SelectMixin from 'Mixins/SelectMixin'
  import { validationMixin } from 'vuelidate'

  export default {
    name: 'ks-select',
    components: {
      Multiselect,
    },
    mixins: [ SelectMixin, validationMixin ],
    props: {
      noneSelectedLabel: {
        type: String,
        default: 'All',
      },
    },
  }
</script>

<style lang="scss">
  @use "~Styles/mixins";
  .ks-vue-component .view-mode {
    @include mixins.view-mode;
  }
</style>
